import Avatar from 'src/Components/Avatar'
import withComposedClassName from 'src/composables/withComposedClassName'

import styles from './PrequalAvatar.module.scss'

const PrequalAvatar = withComposedClassName(styles.root)(Avatar)

export default PrequalAvatar
